/**
 * Ventana encuesta ambiente laboral (vie–dom). Calendario operativo Excel 2026.
 */

/** Fechas fijas Excel — encuesta alumnos y teachers (ciclos 06–12). */
export const ORDEN_CALENDARIO_EXCEL = ['06_26', '07_26', '08_26', '09_26', '10_26', '11_26', '12_26']

export const VENTANAS_EXCEL_CICLOS = {
  '06_26': {
    fecha_inicio: '2026-07-10', fecha_fin: '2026-07-12', semana_aplicacion: 4,
    fecha_reporte: '2026-07-13', fecha_junta: '2026-07-15',
  },
  '07_26': {
    fecha_inicio: '2026-08-14', fecha_fin: '2026-08-16', semana_aplicacion: 4,
    fecha_reporte: '2026-08-17', fecha_junta: '2026-08-19',
  },
  '08_26': {
    fecha_inicio: '2026-09-11', fecha_fin: '2026-09-13', semana_aplicacion: 4,
    fecha_reporte: '2026-09-14', fecha_junta: '2026-09-16',
  },
  '09_26': {
    fecha_inicio: '2026-10-09', fecha_fin: '2026-10-11', semana_aplicacion: 4,
    fecha_reporte: '2026-10-12', fecha_junta: '2026-10-14',
  },
  '10_26': {
    fecha_inicio: '2026-11-06', fecha_fin: '2026-11-08', semana_aplicacion: 4,
    fecha_reporte: '2026-11-09', fecha_junta: '2026-11-11',
  },
  '11_26': {
    fecha_inicio: '2026-12-04', fecha_fin: '2026-12-06', semana_aplicacion: 4,
    fecha_reporte: '2026-12-07', fecha_junta: '2026-12-09',
  },
  '12_26': {
    fecha_inicio: '2027-01-22', fecha_fin: '2027-01-24', semana_aplicacion: 5,
    fecha_reporte: '2027-01-25', fecha_junta: '2027-01-27',
  },
}

export function claveCicloDesdeNombre (nombre) {
  const m = String(nombre || '').match(/(\d{1,2}_\d{2})/)
  return m ? m[1] : null
}

function toDateOnly (value) {
  if (!value) return null
  const text = String(value).slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? text : null
}

function parseYmd (ymd) {
  const [y, m, d] = ymd.split('-').map(Number)
  return new Date(y, m - 1, d, 12, 0, 0)
}

function formatYmd (date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

function hoyYmd () {
  return formatYmd(new Date())
}

function diasCiclo (fechaInicio, fechaFin) {
  const inicio = toDateOnly(fechaInicio)
  const fin = toDateOnly(fechaFin)
  if (!inicio || !fin) return 0
  const diff = parseYmd(fin) - parseYmd(inicio)
  return Math.floor(diff / 86400000) + 1
}

function ultimoViernesDomingo (fechaFin) {
  const fin = toDateOnly(fechaFin)
  if (!fin) return null
  const e = parseYmd(fin)
  const fri = new Date(e)
  while (fri.getDay() !== 5) fri.setDate(fri.getDate() - 1)
  const sun = new Date(fri)
  sun.setDate(sun.getDate() + 2)
  return { fecha_inicio: formatYmd(fri), fecha_fin: formatYmd(sun) }
}

function ventanaSemana4 (fechaInicio) {
  const inicio = toDateOnly(fechaInicio)
  if (!inicio) return null
  const s = parseYmd(inicio)
  const day21 = new Date(s)
  day21.setDate(day21.getDate() + 21)
  const day27 = new Date(s)
  day27.setDate(day27.getDate() + 27)
  const fri = new Date(day21)
  while (fri.getDay() !== 5) fri.setDate(fri.getDate() + 1)
  if (fri > day27) {
    fri.setTime(day27.getTime())
    while (fri.getDay() !== 5) fri.setDate(fri.getDate() - 1)
  }
  const sun = new Date(fri)
  sun.setDate(sun.getDate() + 2)
  return { fecha_inicio: formatYmd(fri), fecha_fin: formatYmd(sun) }
}

export function buildVentanaEncuestaAmbiente (cicloRow) {
  if (!cicloRow) return null
  const nombre = String(cicloRow.ciclo || cicloRow.nombre || cicloRow.nombre_ciclo || '').trim()
  const clave = claveCicloDesdeNombre(nombre)
  if (clave && VENTANAS_EXCEL_CICLOS[clave]) {
    return { ...VENTANAS_EXCEL_CICLOS[clave] }
  }
  const inicioCiclo = toDateOnly(cicloRow.fecha_inicio_ciclo || cicloRow.fecha_inicio)
  const finCiclo = toDateOnly(cicloRow.fecha_fin_ciclo || cicloRow.fecha_fin)
  const dias = diasCiclo(inicioCiclo, finCiclo)
  if (dias > 28) {
    const ventana = ultimoViernesDomingo(finCiclo)
    if (!ventana) return null
    ventana.semana_aplicacion = 4
    return ventana
  }
  const ventana = ventanaSemana4(inicioCiclo)
  if (!ventana) return null
  ventana.semana_aplicacion = 4
  return ventana
}

export function enVentanaAmbiente (ventana, fechaHoy = hoyYmd()) {
  if (!ventana || !ventana.fecha_inicio || !ventana.fecha_fin) return false
  return fechaHoy >= ventana.fecha_inicio && fechaHoy <= ventana.fecha_fin
}

function formatearFechaVentana (ymd) {
  if (!ymd) return ''
  const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number)
  const meses = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
  ]
  return `${d} de ${meses[m - 1]} de ${y}`
}

export function mensajeFueraDeVentana (ventana, fechaHoy = hoyYmd()) {
  if (!ventana) {
    return 'No se pudo determinar el periodo de aplicación de la encuesta para este ciclo.'
  }
  const inicio = formatearFechaVentana(ventana.fecha_inicio)
  const fin = formatearFechaVentana(ventana.fecha_fin)
  if (fechaHoy < ventana.fecha_inicio) {
    return `La encuesta estará disponible del ${inicio} al ${fin}.`
  }
  return `El periodo de encuesta para este ciclo cerró el ${fin}.`
}

export function hoyYmdAmbiente () {
  return hoyYmd()
}

/**
 * Ciclo sugerido para encuesta docente: ventana activa hoy → ciclo en curso → más reciente.
 */
export function idCicloSugeridoEncuestaAmbiente (ciclos, fechaHoy = hoyYmd()) {
  if (!Array.isArray(ciclos) || !ciclos.length) return null
  for (const c of ciclos) {
    const ventana = buildVentanaEncuestaAmbiente(c)
    if (ventana && enVentanaAmbiente(ventana, fechaHoy)) {
      return c.id_ciclo
    }
  }
  for (const c of ciclos) {
    const ini = toDateOnly(c.fecha_inicio_ciclo)
    const fin = toDateOnly(c.fecha_fin_ciclo)
    if (ini && fin && fechaHoy >= ini && fechaHoy <= fin) {
      return c.id_ciclo
    }
  }
  return ciclos[0].id_ciclo != null ? ciclos[0].id_ciclo : null
}
